<template>
  <button
    class="el-button"
    @click="handleClick"
    :disabled="buttonDisabled || (showLoading && (loading || isLoading))"
    :autofocus="autofocus"
    :type="nativeType"
    :class="[
      type ? 'el-button--' + type : '',
      buttonSize ? 'el-button--' + buttonSize : '',
      {
        'is-disabled': buttonDisabled,
        'is-loading': showLoading && (loading || isLoading),
        'is-plain': plain,
        'is-round': round,
        'is-circle': circle
      }
    ]"
  >
    <i class="el-icon-loading" v-if="showLoading && (loading || isLoading)"></i>
    <i :class="icon" v-if="icon && (!showLoading || (!loading && !isLoading))"></i>
    <span v-if="$slots.default"><slot></slot></span>
    <span v-else-if="action">{{ $t("global.operation." + action) }}</span>
  </button>
</template>

<script>
  import {Button} from 'element-ui'
  import {qunjiReject, qunjiResolve} from 'qunji-common-vue-pc/src/utils/common'

  export default {
    name: 'qunji-button',
    extends: Button,
    props: {
      action: {
        type: String
      },
      showLoading: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        isLoading: false
      }
    },
    methods: {
      handleClick(evt) {
        this.isLoading = true
        let resolve = response => {
          this.isLoading = false
          qunjiResolve(response, this)
        }
        let reject = error => {
          this.isLoading = false
          qunjiReject(error, this)
        }
        this.$emit('click', resolve, reject, evt)
      }
    }
  }
</script>
